import styled from 'styled-components'
import { flexDirection, FlexDirectionProps } from 'styled-system'
import { themeGet } from '@styled-system/theme-get'

import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

import { LANDING_MAX_CONTENT_WIDTH_PX } from 'Constants/Landing'

const shouldForwardProp = (prop: string | number) => {
  return !DIV_SHOULD_FORWARD_PROP.includes(String(prop))
}

export const Content = styled.div.withConfig({
  shouldForwardProp,
})<FlexDirectionProps>`
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-width: ${LANDING_MAX_CONTENT_WIDTH_PX}px;
  gap: ${themeGet('space.11')}px;

  ${flexDirection}
`

export const ArtsHolder = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  height: 100%;

  > svg {
    margin-top: 25px;
    z-index: 1;
  }
`

export const Line = styled.div`
  position: absolute;
  top: 0;
  left: 50%;
  width: 1px;
  height: 100%;
  background-color: ${themeGet('colors.border.slight')};
`
